import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output, QueryList, ViewChildren,
  ViewEncapsulation
} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {FormRichFieldConfig} from '../../../../model/api/form-rich-field-config';
import {CcSubFormBaseComponent} from "../cc-sub-form-base.component";
import {FormFieldConfig} from "../../../../model/api/form-field-config";
import {Table} from "primeng/table";

@Component({
  selector: 'cc-table-form-field[formRichFieldConfig][formRecords]',
  templateUrl: './table-form-field.component.html',
  styleUrls: ['./table-form-field.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    TranslateService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableFormFieldComponent extends CcSubFormBaseComponent {

  FieldTypes = FormFieldConfig.TYPE;

  fieldValueMap = {};

  @Input()
  formRichFieldConfig: FormRichFieldConfig;

  @Input()
  formRecords: any[];
  @Output()
  formRecordsChange = new EventEmitter<any[]>();

  @Input()
  required: boolean;

  @Input()
  disabled: boolean;

  @Input()
  transPartKey: string;

  submitted: boolean;

  @ViewChildren('ccSubForm')
  subFormComponents: QueryList<CcSubFormBaseComponent>;

  @ViewChildren('tableFormFieldTable')
  tableFormFieldTable: Table;

  constructor(cdref: ChangeDetectorRef,
              messageService: MessageService,
              translateService: TranslateService,
              private confirmationService: ConfirmationService) {
    super(cdref, messageService, translateService);
  }

  ngAfterContentInit() {
    super.ngAfterContentInit();
    this.reloadFieldValueMap();
  }

  delete(index: number) {
    this.formRecords.splice(index, 1);
  }

  public reloadFieldValueMap(): void {
    // setTimeout(() => {
    if (this.formRichFieldConfig && this.formRecords) {
      this.formRecords.forEach((value, recordIndex) => {
        if (this.formRichFieldConfig.style)
          this.fieldValueMap['style-' + recordIndex] =
            this.formRichFieldConfig.style(value);
        this.formRichFieldConfig.fields.forEach((groupConf, groupIndex) => {
          if (groupConf.hidden)
            this.fieldValueMap['hiddenGroup-' + groupIndex + '_' + recordIndex] = groupConf.hidden(value);
          groupConf.fields.forEach((fieldConf, fieldIndex) => {
            if (fieldConf.hidden)
              this.fieldValueMap['hiddenField-' + groupIndex + '_' + fieldIndex + '_' + recordIndex] = fieldConf.hidden(value);
          });
        });
      });
      if (this.formRichFieldConfig.canDelete)
        this.fieldValueMap['canDelete'] = this.formRichFieldConfig.canDelete(this.formRecords);
      if (this.formRichFieldConfig.canAdd)
        this.fieldValueMap['canAdd'] = this.formRichFieldConfig.canAdd(this.formRecords);
      if (this.subFormComponents)
        this.subFormComponents.forEach(ccForm => ccForm.reloadFieldValueMap());
    }
    super.reloadFieldValueMap();
  }

}

